import { TAdminData } from 'views/types/admins';
import { create, useStore } from 'zustand';

interface AdminsFilter {
  role?: string;
  status?: 'active' | 'inactive';
  online?: boolean;
}

interface IAdminStore {
  admins: TAdminData[];
  loading: boolean;
  selectedAdmin: TAdminData | null;
  currentAdmin: TAdminData | null;
  filters: AdminsFilter;
  setAdmins: (admins: TAdminData[]) => void;
  setLoading: (loading: boolean) => void;
  setSelectedAdmin: (admin: TAdminData | null) => void;
  setCurrentAdmin: (admin: TAdminData | null) => void;
  setFilters: (filters: AdminsFilter) => void;
}

export const adminStore = create<IAdminStore>(set => ({
  admins: [],
  loading: false,
  selectedAdmin: null,
  currentAdmin: null,
  filters: {},
  setLoading: loading => set({ loading }),
  setAdmins: admins => set({ admins }),
  setSelectedAdmin: admin => set({ selectedAdmin: admin }),
  setCurrentAdmin: admin => set({ currentAdmin: admin }),
  setFilters: filters => set({ filters }),
}));

export const useAdminsStore = () => useStore(adminStore);
